import { clsx } from 'clsx'
import type { ReactNode } from 'react'

interface AlertProps {
  variant?: 'error' | 'success' | 'info'
  children: ReactNode
  className?: string
}

export function Alert({ variant = 'info', children, className }: AlertProps) {
  const variantStyles = {
    error: 'bg-red-50 border-red-300 text-red-700',
    success: 'bg-green-50 border-green-300 text-green-700',
    info: 'bg-blue-50 border-blue-300 text-blue-700',
  }

  return (
    <div
      className={clsx('border-2 rounded-card p-4 font-title', variantStyles[variant], className)}
    >
      {children}
    </div>
  )
}
